module.exports = __webpack_public_path__ + "static/37-eb1032ded99809143f7c871ccea918af.jpg";